<app-panel-header-image-view *ngIf="competition" [title]="competition?.Name" [banner_image]="provideBanner(competition)"
  [logo]="competition?.Country ? true : false">
  <app-third-nav-tab-component [elements]="routes"></app-third-nav-tab-component>
  <div class="downtitle_behind">
    <div class="date-competition">{{competition | dateEvent : competition.DFrom : competition.DTo : 'to' + ''}}</div>
    <div class="country-wrapper">
      <div>{{competition.Place}}, {{competition.CountryName}}</div>
      <img class="flag" [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + competition?.Country +'.svg'" />
    </div>
  </div>
  <div class="banner__content__second__logo">
    <div class="img-wrapper">
      <img [lazyLoad]="competition?.Logo?.URL" />
      <div class="img-icons-wrapper">
        <div class="img-position results" *ngIf="competition.WithRes"> </div>

        <a [target]="'_blank'" *ngIf="competition.IsLive" [href]="competition.YoutubeLive">
          <div class="img-position live">

          </div>
        </a>
      </div>
    </div>
  </div>
</app-panel-header-image-view>

<div *ngIf="competition?.YoutubeLive">
  <a href="{{competition?.YoutubeLive}}">
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 4000 1000">
      <rect class="st0" x="-4020" width="4000" height="1000" />
      <g>
        <g>
          <g>
            <path class="st8"
              d="M-2075.05,256.82h-66.03v-45.54h66.03v-68.31h47.06v68.31h66.03v45.54h-66.03v68.31h-47.06v-68.31Z" />
            <g>
              <path class="st1"
                d="M-3266.47,374.71c0-34.26,26.35-53.36,89.6-59.95-1.32-11.86-8.56-17.13-23.06-17.13-11.86,0-24.38,4.61-41.51,13.84l-19.76-36.89c23.06-13.84,46.78-21.74,72.47-21.74,42.82,0,68.52,23.06,68.52,77.08v91.58h-46.12l-3.95-15.81h-1.32c-13.18,11.86-27.67,19.76-45.46,19.76-30.97,0-49.41-23.72-49.41-50.73ZM-3176.87,370.76v-22.4c-27.01,3.95-35.58,12.52-35.58,21.74,0,7.58,5.27,11.86,15.15,11.86,9.22,0,14.49-4.61,20.42-11.2Z" />
              <path class="st1"
                d="M-3089.13,256.78h46.12l3.95,28.33h1.32c12.19-22.4,30.64-32.28,46.78-32.28,10.21,0,15.81,1.32,20.42,3.29l-9.22,48.75c-5.93-1.32-11.2-2.64-18.45-2.64-11.86,0-26.35,7.25-34.26,27.67v91.58h-56.66v-164.71Z" />
              <path class="st1"
                d="M-2799.25,192.22h56.66v53.37l-2.64,28.33c11.2-9.88,27.01-21.08,49.41-21.08,36.24,0,51.39,26.35,51.39,67.2v101.46h-56.66v-94.21c0-21.08-5.27-26.35-16.47-26.35-10.54,0-16.47,4.61-25.04,12.52v108.05h-56.66v-229.27Z" />
              <path class="st1"
                d="M-2620.62,339.14c0-53.37,38.87-86.31,79.06-86.31,48.75,0,71.81,35.58,71.81,79.72,0,9.88-1.32,19.77-2.31,23.72h-93.88c5.27,19.76,19.76,26.35,38.21,26.35,11.2,0,21.74-3.29,33.6-9.88l18.45,33.6c-17.79,12.52-41.51,19.11-59.95,19.11-48.09,0-84.99-31.62-84.99-86.31ZM-2517.84,319.37c0-12.52-5.27-23.72-22.4-23.72-12.52,0-23.06,7.25-26.35,23.72h48.75Z" />
              <path class="st1"
                d="M-2440.72,256.78h46.12l3.95,28.33h1.32c12.19-22.4,30.64-32.28,46.78-32.28,10.21,0,15.81,1.32,20.42,3.29l-9.22,48.75c-5.93-1.32-11.2-2.64-18.45-2.64-11.86,0-26.35,7.25-34.26,27.67v91.58h-56.66v-164.71Z" />
              <path class="st1"
                d="M-2297.22,480.12l9.88-42.82c2.96.66,7.25,1.98,10.54,1.98,15.15,0,22.4-6.59,25.69-16.47l1.98-7.25-62.59-158.78h56.66l19.76,63.25c4.61,15.15,7.91,30.31,11.86,46.78h1.32c3.29-15.81,6.59-30.97,10.54-46.78l16.47-63.25h54.02l-55.34,162.07c-17.13,44.47-34.92,64.57-75.77,64.57-11.2,0-17.79-1.32-25.04-3.29Z" />
            </g>
          </g>
          <g>
            <path class="st1"
              d="M-2876.11,382.74c-24.33,0-44.12-19.79-44.12-44.12s19.79-44.12,44.12-44.12c9.7,0,18.67,3.15,25.97,8.48l31.23-27.25c-15.31-14.21-35.82-22.9-58.36-22.9-47.38,0-85.79,38.41-85.79,85.79s38.41,85.79,85.79,85.79c22.54,0,43.05-8.69,58.36-22.9l-31.23-27.25c-7.29,5.33-16.26,8.48-25.96,8.48Z" />
            <path class="st9"
              d="M-2876.11,304.26c-18.98,0-34.36,15.38-34.36,34.36s15.38,34.36,34.36,34.36,34.36-15.38,34.36-34.36-15.38-34.36-34.36-34.36ZM-2876.11,356.36c-9.8,0-17.74-7.94-17.74-17.74s7.94-17.74,17.74-17.74,17.74,7.94,17.74,17.74-7.94,17.74-17.74,17.74Z" />
          </g>
        </g>
        <circle class="st10" cx="-2876.11" cy="338.62" r="17.74" />
      </g>
      <text class="st4" transform="translate(-3266.47 594.47)">
        <tspan x="0" y="0">stream events live</tspan>
      </text>
      <rect class="st8" x="-3284.96" y="698.61" width="563.12" height="157.51" rx="-1079.36" ry="-1079.36" />
      <text class="st5" transform="translate(-3212.45 805.65)">
        <tspan x="0" y="0" xml:space="preserve">VISIT &gt;</tspan>
      </text>
      <rect class="st0" width="4000" height="1000" />
      <g>
        <g>
          <g>
            <path class="st8"
              d="M1944.95,256.82h-66.03v-45.54h66.03v-68.31h47.06v68.31h66.03v45.54h-66.03v68.31h-47.06v-68.31Z" />
            <g>
              <path class="st1"
                d="M753.53,374.71c0-34.26,26.35-53.36,89.6-59.95-1.32-11.86-8.56-17.13-23.06-17.13-11.86,0-24.38,4.61-41.51,13.84l-19.76-36.89c23.06-13.84,46.78-21.74,72.47-21.74,42.82,0,68.52,23.06,68.52,77.08v91.58h-46.12l-3.95-15.81h-1.32c-13.18,11.86-27.67,19.76-45.46,19.76-30.97,0-49.41-23.72-49.41-50.73ZM843.13,370.76v-22.4c-27.01,3.95-35.58,12.52-35.58,21.74,0,7.58,5.27,11.86,15.15,11.86,9.22,0,14.49-4.61,20.42-11.2Z" />
              <path class="st1"
                d="M930.87,256.78h46.12l3.95,28.33h1.32c12.19-22.4,30.64-32.28,46.78-32.28,10.21,0,15.81,1.32,20.42,3.29l-9.22,48.75c-5.93-1.32-11.2-2.64-18.45-2.64-11.86,0-26.35,7.25-34.26,27.67v91.58h-56.66v-164.71Z" />
              <path class="st1"
                d="M1220.75,192.22h56.66v53.37l-2.64,28.33c11.2-9.88,27.01-21.08,49.41-21.08,36.24,0,51.39,26.35,51.39,67.2v101.46h-56.66v-94.21c0-21.08-5.27-26.35-16.47-26.35-10.54,0-16.47,4.61-25.04,12.52v108.05h-56.66v-229.27Z" />
              <path class="st1"
                d="M1399.38,339.14c0-53.37,38.87-86.31,79.06-86.31,48.75,0,71.81,35.58,71.81,79.72,0,9.88-1.32,19.77-2.31,23.72h-93.88c5.27,19.76,19.76,26.35,38.21,26.35,11.2,0,21.74-3.29,33.6-9.88l18.45,33.6c-17.79,12.52-41.51,19.11-59.95,19.11-48.09,0-84.99-31.62-84.99-86.31ZM1502.16,319.37c0-12.52-5.27-23.72-22.4-23.72-12.52,0-23.06,7.25-26.35,23.72h48.75Z" />
              <path class="st1"
                d="M1579.28,256.78h46.12l3.95,28.33h1.32c12.19-22.4,30.64-32.28,46.78-32.28,10.21,0,15.81,1.32,20.42,3.29l-9.22,48.75c-5.93-1.32-11.2-2.64-18.45-2.64-11.86,0-26.35,7.25-34.26,27.67v91.58h-56.66v-164.71Z" />
              <path class="st1"
                d="M1722.78,480.12l9.88-42.82c2.96.66,7.25,1.98,10.54,1.98,15.15,0,22.4-6.59,25.69-16.47l1.98-7.25-62.59-158.78h56.66l19.76,63.25c4.61,15.15,7.91,30.31,11.86,46.78h1.32c3.29-15.81,6.59-30.97,10.54-46.78l16.47-63.25h54.02l-55.34,162.07c-17.13,44.47-34.92,64.57-75.77,64.57-11.2,0-17.79-1.32-25.04-3.29Z" />
            </g>
          </g>
          <g>
            <path class="st1"
              d="M1143.89,382.74c-24.33,0-44.12-19.79-44.12-44.12s19.79-44.12,44.12-44.12c9.7,0,18.67,3.15,25.97,8.48l31.23-27.25c-15.31-14.21-35.82-22.9-58.36-22.9-47.38,0-85.79,38.41-85.79,85.79s38.41,85.79,85.79,85.79c22.54,0,43.05-8.69,58.36-22.9l-31.23-27.25c-7.29,5.33-16.26,8.48-25.96,8.48Z" />
            <path class="st9"
              d="M1143.89,304.26c-18.98,0-34.36,15.38-34.36,34.36s15.38,34.36,34.36,34.36,34.36-15.38,34.36-34.36-15.38-34.36-34.36-34.36ZM1143.89,356.36c-9.8,0-17.74-7.94-17.74-17.74s7.94-17.74,17.74-17.74,17.74,7.94,17.74,17.74-7.94,17.74-17.74,17.74Z" />
          </g>
        </g>
        <circle class="st10" cx="1143.89" cy="338.62" r="17.74" />
      </g>
      <text class="st7" transform="translate(753.53 594.47)">
        <tspan class="st2" x="0" y="0">watch event </tspan>
        <tspan class="st6" x="641.76" y="0">live </tspan>
        <tspan class="st3" x="850.13" y="0">or replay later</tspan>
      </text>
      <rect class="st8" x="735.04" y="698.61" width="563.12" height="157.51" rx="50" ry="50" />
      <text class="st5" transform="translate(807.55 805.65)">
        <tspan x="0" y="0" xml:space="preserve">VISIT &gt;</tspan>
      </text>
    </svg>
  </a>
</div>

<app-app-content-page-wrapper>
  <app-news-panel [style.height]="activeRoute" [title]="'Reviews' | transloco" [news]="day_review_news"
    class="day-review-news"></app-news-panel>
  <router-outlet></router-outlet>
  <app-news-panel appRouterHide [pathsToBeHide]="['news']" [title]="'related_news' | transloco"
    [news]="news"></app-news-panel>
</app-app-content-page-wrapper>
